import { LANGUAGE_PATH_PATTERN } from '../shared/languages';

export const ROUTES_ID = {
  CART: 'CART',
  CHECKOUT: 'CHECKOUT',
  CONFIRMATION: 'CONFIRMATION',
  TRIAL: 'TRIAL',
  TRIAL_CONFIRMATION: 'TRIAL_CONFIRMATION',
} as const;

export type RouteId = (typeof ROUTES_ID)[keyof typeof ROUTES_ID];

const languagePrefix = `/:language(${LANGUAGE_PATH_PATTERN})?`;

export const ROUTES_PATHS: Record<RouteId, string> = {
  [ROUTES_ID.CART]: languagePrefix,
  [ROUTES_ID.CHECKOUT]: `${languagePrefix}/checkout`,
  [ROUTES_ID.CONFIRMATION]: `${languagePrefix}/confirmation`,
  [ROUTES_ID.TRIAL]: `${languagePrefix}/trial/:trialName`,
  [ROUTES_ID.TRIAL_CONFIRMATION]: `${languagePrefix}/trial/:trialName/confirmation`,
};
